"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SQLError = exports.CustomBusinessError = exports.QueriesDisabledBusinessError = exports.OtpFailureError = exports.QueryAnalyzeFailError = exports.ServiceUnavailableError = exports.UniqueFieldViolationError = exports.FreeTrialLimitReachedError = exports.RunInBackgroundBusinessError = exports.TimeoutBusinessError = exports.AlreadyLoggedInBusinessError = exports.QuotaExceededBusinessError = exports.ValidationBusinessError = exports.MovedPermanentlyError = exports.InternalError = exports.NotAllowedError = exports.NotFoundError = exports.ValidationError = exports.ClientError = exports.PayloadTooLargeBusinessError = exports.AuthenticationError = exports.NotFoundBusinessError = exports.NotUpToDateBusinessError = exports.AuthenticationBusinessError = exports.AlreadyExistsBusinessError = exports.HasBeenDeletedBusinessError = exports.NotAllowedBusinessError = exports.IntegrationBusinessError = exports.InvalidOTPError = exports.EmptyMandatoryFieldError = exports.LicenseNotValidError = exports.UserNotFoundError = exports.TeamChangedBusinessError = exports.PartialFailureBusinessError = exports.BUSINESS_ERROR = exports.CustomError = void 0;
class CustomError extends Error {
    constructor(message, status, name) {
        super(message);
        this.isCustom = true;
        this.status = status ? status : 500;
        this.name = name ? name : "InternalError";
    }
}
exports.CustomError = CustomError;
class CustomBusinessError extends Error {
    constructor(message, errorStatus, name, value) {
        super(message);
        this.isBusinessError = true;
        this.status = 200;
        this.errorStatus = errorStatus;
        this.name = name ? name : "InternalError";
        if (value)
            this.value = value;
    }
}
exports.CustomBusinessError = CustomBusinessError;
/**
 * Enum all the business error (return "200" status, the error is
 * contained within a 'code_response' attribute)
 */
var BUSINESS_ERROR;
(function (BUSINESS_ERROR) {
    BUSINESS_ERROR["SUCCESS"] = "SUCC";
    BUSINESS_ERROR["NOT_FOUND"] = "NFND";
    BUSINESS_ERROR["NOT_ALLOWED"] = "NALW";
    BUSINESS_ERROR["NOT_UP_TO_DATE"] = "NUTD";
    BUSINESS_ERROR["TEAM_CHANGED"] = "TCHG";
    BUSINESS_ERROR["ALREADY_EXISTS"] = "AEXT";
    BUSINESS_ERROR["AUTHENTICATION"] = "AUTH";
    BUSINESS_ERROR["HAS_BEEN_DELETED"] = "HBDL";
    BUSINESS_ERROR["PARTIAL_SUCCESS"] = "PSUC";
    BUSINESS_ERROR["USER_NOT_FOUND"] = "UNFD";
    BUSINESS_ERROR["LICENSE_NOT_VALID"] = "LNVD";
    BUSINESS_ERROR["INVALID_OTP"] = "IOTP";
    BUSINESS_ERROR["OTP_FAILURE"] = "OTPF";
    BUSINESS_ERROR["QUOTA_EXCEEDED"] = "QTEX";
    BUSINESS_ERROR["PAYLOAD_TOO_LARGE"] = "PLTL";
    BUSINESS_ERROR["ALREADY_LOGGED_IN"] = "ALGI";
    BUSINESS_ERROR["TIMEOUT"] = "TMOT";
    BUSINESS_ERROR["RUN_IN_BACKGROUND"] = "RIBG";
    BUSINESS_ERROR["EMPTY_MANDATORY_FIELD"] = "EMFD";
    BUSINESS_ERROR["VALIDATION_ERROR"] = "VERR";
    BUSINESS_ERROR["FREE_TRIAL_LIMIT_REACHED"] = "FTLR";
    BUSINESS_ERROR["UNIQUE_FIELD_VIOLATION"] = "UNFV";
    BUSINESS_ERROR["QUERY_ANALYZE_FAIL_ERROR"] = "QRFL";
    BUSINESS_ERROR["INTEGRATION"] = "INTG";
    BUSINESS_ERROR["QUERIES_DISABLED"] = "QDIS";
    BUSINESS_ERROR["SQL_ERROR"] = "SQLE";
})(BUSINESS_ERROR || (exports.BUSINESS_ERROR = BUSINESS_ERROR = {}));
class PartialFailureBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.PARTIAL_SUCCESS, "PartialSuccess", value);
    }
}
exports.PartialFailureBusinessError = PartialFailureBusinessError;
class TeamChangedBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.TEAM_CHANGED, "TeamChanged", value);
    }
}
exports.TeamChangedBusinessError = TeamChangedBusinessError;
class UserNotFoundError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.USER_NOT_FOUND, "UserNotFound", value);
    }
}
exports.UserNotFoundError = UserNotFoundError;
class LicenseNotValidError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.LICENSE_NOT_VALID, "LicenseNotValid", value);
    }
}
exports.LicenseNotValidError = LicenseNotValidError;
class EmptyMandatoryFieldError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.EMPTY_MANDATORY_FIELD, "EmptyMandatoryField", value);
    }
}
exports.EmptyMandatoryFieldError = EmptyMandatoryFieldError;
class ValidationBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.VALIDATION_ERROR, "ValidationError", value);
    }
}
exports.ValidationBusinessError = ValidationBusinessError;
class FreeTrialLimitReachedError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.FREE_TRIAL_LIMIT_REACHED, "FreeTrialError", value);
    }
}
exports.FreeTrialLimitReachedError = FreeTrialLimitReachedError;
class InvalidOTPError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.INVALID_OTP, "InvalidOTP", value);
    }
}
exports.InvalidOTPError = InvalidOTPError;
class NotFoundBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.NOT_FOUND, "NotFoundError", value);
    }
}
exports.NotFoundBusinessError = NotFoundBusinessError;
class NotAllowedBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.NOT_ALLOWED, "NotAllowedError", value);
    }
}
exports.NotAllowedBusinessError = NotAllowedBusinessError;
class HasBeenDeletedBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.HAS_BEEN_DELETED, "HasBeenDeleted", value);
    }
}
exports.HasBeenDeletedBusinessError = HasBeenDeletedBusinessError;
class RunInBackgroundBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.RUN_IN_BACKGROUND, "RunInBackground", value);
    }
}
exports.RunInBackgroundBusinessError = RunInBackgroundBusinessError;
class AlreadyExistsBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.ALREADY_EXISTS, "AlreadyExistsError", value);
    }
}
exports.AlreadyExistsBusinessError = AlreadyExistsBusinessError;
class NotUpToDateBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.NOT_UP_TO_DATE, "NotUpToDateError", value);
    }
}
exports.NotUpToDateBusinessError = NotUpToDateBusinessError;
class AuthenticationBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.AUTHENTICATION, "AuthenticationError", value);
    }
}
exports.AuthenticationBusinessError = AuthenticationBusinessError;
class IntegrationBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.INTEGRATION, "IntegrationError", value);
    }
}
exports.IntegrationBusinessError = IntegrationBusinessError;
class QuotaExceededBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.QUOTA_EXCEEDED, "QuotaExceededError", value);
    }
}
exports.QuotaExceededBusinessError = QuotaExceededBusinessError;
class PayloadTooLargeBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.PAYLOAD_TOO_LARGE, "PayloadTooLargeError", value);
    }
}
exports.PayloadTooLargeBusinessError = PayloadTooLargeBusinessError;
class AlreadyLoggedInBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.ALREADY_LOGGED_IN, "AlreadyLoggedInError", value);
    }
}
exports.AlreadyLoggedInBusinessError = AlreadyLoggedInBusinessError;
class TimeoutBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.TIMEOUT, "Timeout", value);
    }
}
exports.TimeoutBusinessError = TimeoutBusinessError;
class UniqueFieldViolationError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.UNIQUE_FIELD_VIOLATION, "UniqueFieldViolationError", value);
    }
}
exports.UniqueFieldViolationError = UniqueFieldViolationError;
class QueryAnalyzeFailError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.QUERY_ANALYZE_FAIL_ERROR, "QueryAnalyzeFailError", value);
    }
}
exports.QueryAnalyzeFailError = QueryAnalyzeFailError;
class QueriesDisabledBusinessError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.QUERIES_DISABLED, "QueriesDisabled", value);
    }
}
exports.QueriesDisabledBusinessError = QueriesDisabledBusinessError;
class OtpFailureError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.OTP_FAILURE, "OTPFailureError", value);
    }
}
exports.OtpFailureError = OtpFailureError;
class SQLError extends CustomBusinessError {
    constructor(message, value) {
        super(message, BUSINESS_ERROR.SQL_ERROR, "SQLError", value);
    }
}
exports.SQLError = SQLError;
class MovedPermanentlyError extends CustomError {
    constructor(message) {
        super(message, 301, "MovedPermanentlyError");
    }
}
exports.MovedPermanentlyError = MovedPermanentlyError;
class AuthenticationError extends CustomError {
    constructor(message) {
        super(message, 401, "AuthenticationError");
    }
}
exports.AuthenticationError = AuthenticationError;
class ClientError extends CustomError {
    constructor(message) {
        super(message, 400, "ClientError");
    }
}
exports.ClientError = ClientError;
class ValidationError extends CustomError {
    constructor(message) {
        super(message, 422, "ValidationError");
    }
}
exports.ValidationError = ValidationError;
class NotFoundError extends CustomError {
    constructor(message) {
        super(message, 404, "NotFoundError");
    }
}
exports.NotFoundError = NotFoundError;
class NotAllowedError extends CustomError {
    constructor(message) {
        super(message, 405, "NotAllowedError");
    }
}
exports.NotAllowedError = NotAllowedError;
class InternalError extends CustomError {
    constructor(message) {
        super(message, 500, "InternalError");
    }
}
exports.InternalError = InternalError;
class ServiceUnavailableError extends CustomError {
    constructor(message) {
        super(message, 503, "ServiceUnavailable");
    }
}
exports.ServiceUnavailableError = ServiceUnavailableError;
